<template>
  <div>
    <v-dialog v-model="internalDialog" max-width="500px" scrollable>
      <v-overlay :value="overlayComponent">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card class="text-center">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-card-text>
            <v-row>
              <v-col cols="6" class="text-left pt-10">
                <h3><strong>ยกเลิกรายการนี้</strong></h3>
              </v-col>
              <v-col cols="6" class="pt-10">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="formDeleteBooking.sendRemarkRemove"
                  label="แจ้งเตือนหมายเหตุในการยกเลิก"
                ></v-checkbox>
                <v-textarea
                  v-model="formDeleteBooking.remarkRemove"
                  outlined
                  label="หมายเหตุในการยกเลิก"
                  auto-grow
                  required
                  dense
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-autocomplete
                  v-model="formDeleteBooking.empSelect"
                  :items="employeeAdminName"
                  label="พนักงานที่รับนัดหมาย"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn
                elevation="2"
                color="#173053"
                dark
                large
                block
                @click="confirmCancel()"
                >ยกเลิกรายการนี้</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment'
export default {
  name: 'DialogDeleteBooking',
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    dataDeleteBooking: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      languageSelect: 0,
      valid: true,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      internalDialog: this.value,
      formDeleteBooking: {
        remarkRemove: '',
        empSelect: '',
        sendRemarkRemove: false
      },
      employeeAdminName: [],
      overlayComponent: false
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
      if (val) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
        this.clearData()
        this.getEmpAdmin(this.dataDeleteBooking)
      }
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    }
  },
  methods: {
    async clearData () {
      this.formDeleteBooking = {
        remarkRemove: '',
        empSelect: '',
        sendRemarkRemove: false
      }
      this.employeeAdminName = []
      this.overlayComponent = false
    },
    close () {
      this.internalDialog = false
    },
    async getEmpAdmin (item) {
      this.employeeAdminName = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?privacyPage=booking&shopId=' +
            item.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (let i = 0; i < rs.length; i++) {
              let d = rs[i]
              if (d.masBranchID === item.masBranchID) {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              } else if (d.masBranchID === null || d.masBranchID === '') {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              }
            }
          }
        })
    },
    async confirmCancel () {
      this.overlayComponent = true
      await this.$nextTick() // รอให้ overlay render ก่อน
      const isValid = this.$refs.form.validate()
      if (isValid) {
        await this.submitConfirmCancel()
      } else {
        this.overlayComponent = false
      }
    },
    async submitConfirmCancel () {
      try {
        this.$swal({
          title: this.languageSelect === 0 ? 'ยืนยันการยกเลิกนัดหมาย' : 'Confirm appointment cancellation',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
          cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
        }).then(async result => {
          this.overlayComponent = true
          const resUpdateLimitBookingTimeEmp = await this.updateLimitBookingTimeEmp()
          if (resUpdateLimitBookingTimeEmp) {
            const bookingTransaction = await this.updateBookingTransaction()
            if (bookingTransaction) {
              await this.updateRemark()
              await this.pushMsglineCancel()
            }
            this.$swal('เรียบร้อย', 'ยกเลิกนัดหมาย เรียบร้อย', 'success')
            this.resetData()
          } else {
            this.$swal(
              'ผิดพลาด',
              'ไม่สามารถยกเลิกนัดหมายได้กรุณาลองใหม่อีกครั้ง',
              'info'
            )
          }
        })
      } catch (error) {
        console.log('error', error)
        this.$swal(
          'ผิดพลาด',
          'ไม่สามารถยกเลิกนัดหมายได้กรุณาลองใหม่อีกครั้ง',
          'info'
        )
      } finally {
        this.overlayComponent = false
      }
    },
    async updateLimitBookingTimeEmp () {
      try {
        let payload = {
          'masBranchID': this.dataDeleteBooking.masBranchID,
          'flowId': this.dataDeleteBooking.flowId,
          'bookingEmpArray': this.dataDeleteBooking.bookingEmpArray,
          'dueDate': this.dataDeleteBooking.dueDateDay,
          'dueTime': this.dataDeleteBooking.timeText,
          'shopId': this.$session.getAll().data.shopId,
          'LAST_USER': this.$session.getAll().data.userName
        }
        const response = await axios.post(this.$DNS_IP + '/employee_vela/delete_imit_booking_emp_multi', payload)
        if (response.data.status === true) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async updateBookingTransaction () {
      try {
        let payload = {
          'bookNo': this.dataDeleteBooking.bookNo,
          'contactDate': moment().format('YYYY-MM-DD HH:mm:ss'),
          'status': 'cancel',
          'statusUse': 'use',
          'shopId': this.$session.getAll().data.shopId,
          'CREATE_USER': this.$session.getAll().data.userName,
          'LAST_USER': this.$session.getAll().data.userName,
          'remarkRemove': this.formDeleteBooking.remarkRemove.replace(/%/g, '%%')
        }
        const response = await axios.post(this.$DNS_IP + '/booking_transaction/add', payload)
        if (response.data.status === true) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async pushMsglineCancel () {
      try {
        let lineUserId = this.dataDeleteBooking.lineUserId || ''
        if (lineUserId !== '') {
          let payload = {
            'bookNo': this.dataDeleteBooking.bookNo,
            'lineUserId': lineUserId,
            'dueDate': this.dataDeleteBooking.dueDateText,
            'flowName': this.dataDeleteBooking.flowName,
            'shopId': this.$session.getAll().data.shopId,
            'tell': this.$session.getAll().data.contactTel,
            'sendRemarkRemove': this.formDeleteBooking.sendRemarkRemove
          }
          const response = await axios.post(this.$DNS_IP + '/Booking/pushMsgCancelBook', payload)
          if (response.data.status === true) {
            return true
          } else {
            return false
          }
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async updateRemark () {
      try {
        let payload = {
          'empSelect': this.formDeleteBooking.empSelect,
          'LAST_USER': this.$session.getAll().data.userName
        }
        const response = await axios.post(this.$DNS_IP + '/Booking/edit/' + this.dataDeleteBooking.bookNo, payload)
        if (response.data.status === true) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async resetData () {
      await this.$emit('resetData')
      this.internalDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VelaStudio/DialogDeleteBooking.vue